document.querySelectorAll('[data-sunoire-video-showcase]').forEach((root) => {
  const player = root.querySelector('[data-video-player]');
  const backdrop = root.querySelector('[data-video-backdrop]');
  const items = Array.from(root.querySelectorAll('[data-video-item]'));
  const tiles = Array.from(root.querySelectorAll('[data-video-open]'));
  const closeBtn = root.querySelector('[data-video-close]');
  const prevBtn = root.querySelector('[data-video-prev]');
  const nextBtn = root.querySelector('[data-video-next]');
  let current = 0;

  function pauseAll() {
    items.forEach((item) => {
      const video = item.querySelector('video');
      if (video) video.pause();
      item.hidden = true;
    });
  }

  function updateNavState() {
    if (prevBtn) prevBtn.disabled = current === 0;
    if (nextBtn) nextBtn.disabled = current === items.length - 1;
  }

  function show(index) {
    pauseAll();
    current = Math.max(0, Math.min(index, items.length - 1));
    updateNavState();
    const item = items[current];
    item.hidden = false;
    const video = item.querySelector('video');
    if (video) {
      video.currentTime = 0;
      // Matches the reference: unmuted autoplay attempted directly from the
      // user's tap (allowed by browsers as a gesture-initiated play). If a
      // browser still blocks it, native controls are already visible so the
      // shopper can just tap play themselves — same graceful fallback as a
      // plain `autoplay` attribute would give.
      video.play().catch(() => {});
    }
  }

  let savedScrollY = 0;

  function lockPageScroll() {
    // Plain `overflow: hidden` on html/body doesn't reliably block touch-drag
    // scrolling on mobile (a well-known cross-browser gap). Pinning the body
    // in place at its current offset via position:fixed blocks it completely,
    // regardless of touch, wheel, or programmatic scroll attempts.
    savedScrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${savedScrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
  }

  function unlockPageScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    window.scrollTo(0, savedScrollY);
  }

  function open(index) {
    player.hidden = false;
    if (backdrop) backdrop.hidden = false;
    lockPageScroll();
    // Force layout so the closed (off-screen "bottom"/transparent) styles are
    // committed before adding .is-open, otherwise the browser can coalesce
    // both style changes into one frame and the transitions never play.
    void player.offsetWidth;
    player.classList.add('is-open');
    if (backdrop) backdrop.classList.add('is-open');
    show(index);
  }

  function close() {
    pauseAll();
    player.classList.remove('is-open');
    if (backdrop) backdrop.classList.remove('is-open');
    unlockPageScroll();
    const finish = () => {
      player.hidden = true;
      if (backdrop) backdrop.hidden = true;
    };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      finish();
    } else {
      player.addEventListener('transitionend', finish, { once: true });
    }
  }

  tiles.forEach((tile) => {
    tile.addEventListener('click', () => {
      open(parseInt(tile.dataset.videoIndex, 10));
    });
  });

  if (closeBtn) closeBtn.addEventListener('click', close);
  if (prevBtn) prevBtn.addEventListener('click', () => show(current - 1));
  if (nextBtn) nextBtn.addEventListener('click', () => show(current + 1));
  if (backdrop) backdrop.addEventListener('click', close);
});
